import axios from "axios";
import {get} from "lodash";
import { ProductTour } from "src/components/tour/tour.type";

const BASE_URL = `${process.env.REACT_APP_USERS_API_URL}/users/3.0/product-tours`;

export const productTourApi = {
    fetchProductTours: async (): Promise<ProductTour[]> => {
    const response = await axios.get(
      BASE_URL,
    );
    return get(response, "data.tourResponse", []);
  },
}